import { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { H3, H4 } from '../../styles/FontStyles';
import {
  ArrowChevron,
  Button,
  Collapsable,
  Flexed
} from '../../styles/GlobalComponents';

import { CaptionText, P1, P3 } from '../../styles/FontStyles';

import { color } from '../../styles/GlobalStyles';
import {
  Icon,
  IconPortfolioOrders,
  IconPortfolioRevenue,
  IconPortfolioStaked
} from '../../styles/Icons';
import { BoxPortfolio, SummaryGrid } from './Portfolio.styled';

import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { useAppSelector } from '../../app/hooks';
import { formatUSD, walletsNFTWithdraw } from '../../helpers/helperFunctions';
import { getMyHubsTrading } from './Portfolio.actions';
import { PortfolioTradingItem } from './PortfolioTradingItem';
import { BIG_WHALE, FINUP_HUBS, TRADING } from '../../routes/routes';
import { WithdrawStepsEnum } from './WithdrawHubs/types';
import { WithdrawHubs } from './WithdrawHubs/WithdrawHubs';
import { PackageTrading } from './Portfolio.types';

interface TradingHubSummaryProps {
  setWithdrawStep: Dispatch<SetStateAction<WithdrawStepsEnum>>;
  withdrawStep: WithdrawStepsEnum;
}

export const TradingHubSummary = ({
  withdrawStep,
  setWithdrawStep
}: TradingHubSummaryProps) => {
  const dispatch = useDispatch();
  const [expanded, setExpanded] = useState(true);
  const [withdrawModal, setWithdrawModal] = useState(false);
  const [selectedNFTWallet, setSelectedNFTWallet] = useState<any>(
    walletsNFTWithdraw[0]
  );
  const [packageItem, setPackageItem] = useState<PackageTrading | null>(null);

  const ref = useRef<any>(null);
  const history = useHistory();
  // const height = ref?.current?.clientHeight;
  const [height, setHeight] = useState(ref?.current?.clientHeight);

  const { t } = useTranslation('my_hubs');

  const { trading } = useAppSelector((state) => state.portfolio);
  const { isCanadaRestrictedUser } = useAppSelector(
    (state) => state.auth.userInfo
  );

  useEffect(() => {
    dispatch(getMyHubsTrading());
  }, [dispatch]);

  useEffect(() => {
    setHeight(ref?.current?.clientHeight);
  }, [trading]);

  return (
    <>
      <div style={{ marginBottom: 40 }}>
        <Flexed mb='20' center between>
          <H3>{t('my_trading_hub_summary')}</H3>
        </Flexed>

        <SummaryGrid>
          <BoxPortfolio>
            <Icon mr='16' mrSM='8' color={color.colors.secondary100}>
              <IconPortfolioOrders />
            </Icon>
            <div>
              <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                {t('total_orders')}
              </CaptionText>

              <P1 bold flex alignEnd gap='5px'>
                {formatUSD(trading?.summary?.totalOrderAmount)}
                <P3 mb='1'>USDT</P3>
              </P1>
            </div>
          </BoxPortfolio>

          <BoxPortfolio>
            <Icon mr='16' mrSM='8' color={color.colors.secondary100}>
              <IconPortfolioRevenue />
            </Icon>
            <div>
              <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                {t('max_deposit')}
              </CaptionText>
              <P1 bold flex alignEnd gap='5px'>
                {trading?.summary?.maxDeposit === 'UNLIMITED' ? (
                  'UNLIMITED'
                ) : (
                  <>
                    {formatUSD(Number(trading?.summary?.maxDeposit) || 0)}{' '}
                    <P3 mb='1'>USDT</P3>
                  </>
                )}
              </P1>
            </div>
          </BoxPortfolio>

          <BoxPortfolio>
            <Icon mr='16' mrSM='8' color={color.colors.secondary100}>
              <IconPortfolioStaked />
            </Icon>
            <div>
              <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                {t('trading_binary')}
              </CaptionText>
              <P1 bold flex alignEnd gap='5px'>
                <P1 bold flex alignEnd gap='5px'>
                  {trading?.summary?.tradingBinary}
                  <P3 mb='1'>%</P3>
                </P1>
              </P1>
            </div>
          </BoxPortfolio>
        </SummaryGrid>

        <Flexed center between wrap>
          <Flexed
            mb='20'
            center
            gap='20px'
            pointer
            onClick={() => setExpanded(!expanded)}>
            <H4>{t('my_trading_hub_nfts_summary')}</H4>
            <ArrowChevron direction={expanded ? 'up' : 'down'} />
          </Flexed>
          {!isCanadaRestrictedUser && (
            <Button
              negative
              maxWidth='350px'
              maxWidthSM='100%'
              onClick={() => history.push(FINUP_HUBS)}>
              {t('buy_higher_membership')}
            </Button>
          )}
        </Flexed>

        <Collapsable expanded={expanded} elementHeight={height}>
          <div ref={ref}>
            {trading?.userPackages?.map((item: any, i: number) => (
              <PortfolioTradingItem
                key={i}
                item={item}
                withdrawModal={withdrawModal}
                setWithdrawModal={setWithdrawModal}
                setSelectedNFTWallet={setSelectedNFTWallet}
                setPackageItem={setPackageItem}
              />
            ))}
          </div>
        </Collapsable>
      </div>

      <WithdrawHubs
        openModal={withdrawModal}
        setOpenModal={setWithdrawModal}
        packageId={packageItem?.id ?? 0}
        withdrawStep={withdrawStep}
        setWithdrawStep={setWithdrawStep}
        item={packageItem as PackageTrading}
        selectedNFTWallet={selectedNFTWallet}
        setSelectedNFTWallet={setSelectedNFTWallet}
      />
    </>
  );
};
